import { useEffect } from "react";
import { useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteSection } from "store/actions";
import Swal from "sweetalert2";
import { Card } from "./Card";

export const Table = ({ data }) => {
  // eslint-disable-next-line no-lone-blocks
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleEditProject = (slug) => {
    navigate(`/gallery/${slug}`);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleDeleteProject = (slug) => {
    Swal.fire({
      title: "هل تريد حذف الشهادة",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2a89f3",
      cancelButtonColor: "#d33",
      confirmButtonText: "نعم",
      cancelButtonText: "لا",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteSection({ slug: slug, page: "gallery" }));
      }
    });
  };

  const renderCard = data?.map((card, index) => (
    <Card
      index={index}
      handleEdit={handleEditProject}
      handleDelete={handleDeleteProject}
      id={card.slug}
      text={card.heading}
      card={card}
      style={{ position: "unset", marginBottom: "15px" }}
      {...card}
    />
  ));
  return (
    <>
      <div className="dragable_table_body__ ">
        <div className="dragable_table_title__">
          <FormattedMessage id={"title"} />
        </div>
        <div className="dragable_table__">{renderCard}</div>
      </div>
      {isLoading ? <div className="lds-dual-ring"></div> : ""}
    </>
  );
};

export default Table;
